function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagecaption/toggleimagecaptioncommand
 */
import { Command } from 'ckeditor5/src/core';
import ImageBlockEditing from '../image/imageblockediting';
import { getCaptionFromImageModelElement, getCaptionFromModelSelection } from './utils';
/**
 * The toggle image caption command.
 *
 * This command is registered by {@link module:image/imagecaption/imagecaptionediting~ImageCaptionEditing} as the
 * `'toggleImageCaption'` editor command.
 *
 * Executing this command:
 *
 * * either adds or removes the image caption of a selected image (depending on whether the caption is present or not),
 * * removes the image caption if the selection is anchored in one.
 *
 *		// Toggle the presence of the caption.
 *		editor.execute( 'toggleImageCaption' );
 *
 * **Note**: Upon executing this command, the selection will be set on the image if previously anchored in the caption element.
 *
 * **Note**: You can move the selection to the caption right away as it shows up upon executing this command by using
 * the `focusCaptionOnShow` option:
 *
 *		editor.execute( 'toggleImageCaption', { focusCaptionOnShow: true } );
 *
 * @extends module:core/command~Command
 */

var ToggleImageCaptionCommand = /*#__PURE__*/function (_Command) {
  _inherits(ToggleImageCaptionCommand, _Command);

  var _super = _createSuper(ToggleImageCaptionCommand);

  function ToggleImageCaptionCommand() {
    _classCallCheck(this, ToggleImageCaptionCommand);

    return _super.apply(this, arguments);
  }

  _createClass(ToggleImageCaptionCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils'); // Only block images can get captions.

      if (!editor.plugins.has(ImageBlockEditing)) {
        this.isEnabled = false;
        this.value = false;
        return;
      }

      var selection = editor.model.document.selection;
      var selectedElement = selection.getSelectedElement();

      if (!selectedElement) {
        var ancestorCaptionElement = getCaptionFromModelSelection(imageUtils, selection);
        this.isEnabled = !!ancestorCaptionElement;
        this.value = !!ancestorCaptionElement;
        return;
      } // Block images support captions by default but the command should also be enabled for inline
      // images because toggling the caption when one is selected should convert it into a block image.


      this.isEnabled = this.editor.plugins.get('ImageUtils').isImage(selectedElement);

      if (!this.isEnabled) {
        this.value = false;
      } else {
        this.value = !!getCaptionFromImageModelElement(selectedElement);
      }
    }
    /**
     * Executes the command.
     *
     *		editor.execute( 'toggleImageCaption' );
     *
     * @param {Object} [options] Options for the executed command.
     * @param {String} [options.focusCaptionOnShow] When true and the caption shows up, the selection will be moved into it straight away.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var focusCaptionOnShow = options.focusCaptionOnShow;
      this.editor.model.change(function (writer) {
        if (_this.value) {
          _this._hideImageCaption(writer);
        } else {
          _this._showImageCaption(writer, focusCaptionOnShow);
        }
      });
    }
    /**
     * Shows the caption of the `<imageBlock>` or `<imageInline>`. Also:
     *
     * * it converts `<imageInline>` to `<imageBlock>` to show the caption,
     * * it attempts to restore the caption content from the `ImageCaptionEditing` caption registry,
     * * it moves the selection to the caption right away, it the `focusCaptionOnShow` option was set.
     *
     * @private
     * @param {module:engine/model/writer~Writer} writer
     */

  }, {
    key: "_showImageCaption",
    value: function _showImageCaption(writer, focusCaptionOnShow) {
      var model = this.editor.model;
      var selection = model.document.selection;
      var imageCaptionEditing = this.editor.plugins.get('ImageCaptionEditing');
      var selectedImage = selection.getSelectedElement();

      var savedCaption = imageCaptionEditing._getSavedCaption(selectedImage); // Convert imageInline -> image first.


      if (this.editor.plugins.get('ImageUtils').isInlineImage(selectedImage)) {
        this.editor.execute('imageTypeBlock'); // Executing the command created a new model element. Let's pick it again.

        selectedImage = selection.getSelectedElement();
      } // Try restoring the caption from the ImageCaptionEditing plugin storage.


      var newCaptionElement = savedCaption || writer.createElement('caption');
      writer.append(newCaptionElement, selectedImage);

      if (focusCaptionOnShow) {
        writer.setSelection(newCaptionElement, 'in');
      }
    }
    /**
     * Hides the caption of a selected image (or an image caption the selection is anchored to).
     *
     * The content of the caption is stored in the `ImageCaptionEditing` caption registry to make this
     * a reversible action.
     *
     * @private
     * @param {module:engine/model/writer~Writer} writer
     */

  }, {
    key: "_hideImageCaption",
    value: function _hideImageCaption(writer) {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var imageCaptionEditing = editor.plugins.get('ImageCaptionEditing');
      var imageUtils = editor.plugins.get('ImageUtils');
      var selectedImage = selection.getSelectedElement();
      var captionElement;

      if (selectedImage) {
        captionElement = getCaptionFromImageModelElement(selectedImage);
      } else {
        captionElement = getCaptionFromModelSelection(imageUtils, selection);
        selectedImage = captionElement.parent;
      } // Store the caption content so it can be restored quickly if the user changes their mind even if they toggle image<->imageInline.


      imageCaptionEditing._saveCaption(selectedImage, captionElement);

      writer.setSelection(selectedImage, 'on');
      writer.remove(captionElement);
    }
  }]);

  return ToggleImageCaptionCommand;
}(Command);

export { ToggleImageCaptionCommand as default };